export default __webpack_public_path__ + "assets/images/c639e3676ede38f9d119b62f9e3b6b92.png";